import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

interface Project {
  Title: string;
  Description: string;
  Technologies: string[];
  imgs: string[];
  demoLink?: string;
  ghLink?: string;
}

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {
  projects: Project[] = [
    {
      "Title": "TwinTalks",
      "Description": "<span class='underline'>TwinTalks </span> is a <span class='underline'>real-time chat app</span> featuring <span class='underline'>instant messaging</span>, <span class='underline'>online status tracking</span>, and a <span class='underline'>hassle-free signup</span> process with no <span class='underline'>phone number verification</span>. It ensures <span class='underline'>secure</span>, <span class='underline'>anonymous</span>, and <span class='underline'>private communication</span>, providing a seamless user experience.",
      "imgs": [
        "https://github.com/user-attachments/assets/55de3b34-78f1-4504-9c4e-d63a307ad856",
        "https://github.com/user-attachments/assets/dc1fd0ff-4efc-4482-b0f2-19c9fa59eb23",
        "https://github.com/user-attachments/assets/313fd64c-d556-4b89-b81e-fffd879f9939",
        "https://github.com/user-attachments/assets/f4bed3a6-7a35-42bc-8f51-2afda4de91f0",
        "https://github.com/user-attachments/assets/c6d01bd7-8cb5-4e15-be7a-55cb6802303f"
      ],
      "ghLink": "https://github.com/Pa1mekala37/TwinTalks",
      "demoLink": "https://twintalks.up.railway.app",
      "Technologies": [
        "React.js",
        "Node.js",
        "Express.js",
        "MongoDB",
        "Socket.io"
      ]
    },
    {
      "Title": "Nxt Trendz",
      "Description": "Developed <span class='underline'> NXT Trendz</span>, an <span class='underline'> E-commerce website </span> for shopping clothes and electronics. It features <span class='underline'>User Authentication </span> and <span class='underline'>Authorization</span>, a cart system, category-based shopping, sorting, and price filters for an enhanced and secure shopping experience.",
      "imgs": [
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720189181/Portfolio/Screenshot_2024-07-05_at_7.46.07_PM_cxmsnf.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720189190/Portfolio/Screenshot_2024-07-05_at_7.46.27_PM_wtblbg.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720189182/Portfolio/Screenshot_2024-07-05_at_7.47.26_PM_a2erql.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720189187/Portfolio/Screenshot_2024-07-05_at_7.46.45_PM_dunqow.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720189181/Portfolio/Screenshot_2024-07-05_at_7.48.16_PM_xwkdgt.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720189182/Portfolio/Screenshot_2024-07-05_at_7.49.05_PM_kcjzpb.png"
      ],
      "ghLink": "https://github.com/Pa1mekala37/Nxt-Trendz-Ecommerce-Application",
      "demoLink": "https://pvnnxttrendz.ccbp.tech",
      "Technologies": [
        "React.js",
        "Node.js",
        "Express.js",
        "Bootstrap",
        "HTML",
        "CSS"
      ]
    },
    {
      "Title": "TinyLinker",
      "Description": "Developed <span class='underline'> TinyLinker </span>, a <span class='underline'> MERN Stack</span> URL shortener that transforms long URLs into short, manageable links. It includes features for <span class='underline'>Tracking click counts</span>, quick copy functionality, and easy deletion of links for efficient and user-friendly link management.",
      "imgs": [
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720187963/Portfolio/Screenshot_2024-07-05_at_7.19.39_PM_t2ymhk.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720187962/Portfolio/Screenshot_2024-07-05_at_7.19.55_PM_x9zdlx.png"
      ],
      "ghLink": "https://github.com/Pa1mekala37/MERN-URL-Shortener",
      "demoLink": "https://mern-url-shortener-1-k8qr.onrender.com",
      "Technologies": [
        "MongoDB",
        "Express.js",
        "React.js",
        "Node.js",
        "Tailwind"
      ]
    },
    {
      "Title": "Jobby",
      "Description": "Developed <span class='underline'>Jobby App</span> using <span class='underline'>React.js</span>, a web application enabling users to log in, view job listings, and search by title, with filters for <span class='underline'>salary range</span> and <span class='underline'>employment type</span>, including user <span class='underline'>Login and Logout functionality.</span>",
      "imgs": [
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720190124/Portfolio/Screenshot_2024-07-05_at_8.02.55_PM_ouvlcp.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720190124/Portfolio/Screenshot_2024-07-05_at_8.03.20_PM_aoc0g7.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720190124/Portfolio/Screenshot_2024-07-05_at_8.03.41_PM_vo9hi7.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720190126/Portfolio/Screenshot_2024-07-05_at_8.04.07_PM_w4rywg.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720190125/Portfolio/Screenshot_2024-07-05_at_8.04.28_PM_clfq4f.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720190158/Portfolio/Screenshot_2024-07-05_at_8.05.33_PM_znzoh1.png"
      ],
      "ghLink": "https://github.com/Pa1mekala37/Jobby-App",
      "demoLink": "https://pvnjobbyapp.ccbp.tech",
      "Technologies": [
        "React.js",
        "Node.js",
        "Express.js",
        "Bootstrap",
        "HTML",
        "CSS"
      ]
    },
    {
      "Title": "Productify",
      "Description": "Developed <span class='underline'> Productify </span> using MERN Stack for product management. Features include product image upload,<span class='underline'>CRUD operations for products (name, price, description), sorting, listing, deleting, updating, user registration, login,JWT Authentication, pagination</span>",
      "imgs": [
        "https://raw.githubusercontent.com/FSojitra/Registration-Login-and-CRUD-Action-using-MERN-stack/development/MERN.gif"
      ],
      "ghLink": "https://github.com/Pa1mekala37/Registration-Login-and-CRUD-Action-using-MERN-stack",
      "Technologies": [
        "Node.js",
        "Express.js",
        "React.js",
        "MongoDB",
        "JWT",
        "Axios",
        "Material-UI"
      ]
    },
    {
      "Title": "EmployeeHub",
      "Description": "EmployeeHub is an Angular-based employee management system with Material UI Bootstrap. <span class='underline'>It manages candidate details including basic info, Designation, package, experience, search and current company. Features include CRUD operations for candidates, sorting functionality </span> and efficient management of employee data.",
      "imgs": [
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720191942/Portfolio/Screenshot_2024-07-05_at_8.33.51_PM_mqkjef.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720191943/Portfolio/Screenshot_2024-07-05_at_8.34.03_PM_emwkrg.png"
      ],
      "ghLink": "https://github.com/Pa1mekala37/Employee-Management-System-Angular",
      "demoLink": "https://pa1mekala37.github.io/Employee-Management-System-Angular",
      "Technologies": [
        "Angular",
        "SASS",
        "Angular Material UI",
        "Bootstrap",
        "Typescript"
      ]
    },
    {
      "Title": "WhatsApp Messenger",
      "Description": "WhatsApp Messenger is a web application enabling users to<span class='underline'>send WhatsApp messages without saving the recipient's Mobile number</span>It provides a convenient and privacy-focused way to communicate via WhatsApp directly from the web",
      "imgs": [
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720192281/Portfolio/Screenshot_2024-07-05_at_8.40.42_PM_fvhb3a.png"
      ],
      "demoLink": "https://wamsg.ccbp.tech",
      "Technologies": [
        "HTML",
        "CSS",
        "Bootstrap",
        "Javascript"
      ]
    },
    {
      "Title": "FoodMunch",
      "Description": "FoodMunch is a restaurant website  allowing users to order food online. It features a discounts and coupons section for savings. <span class='underline'> Customers can conveniently browse the menu </span>, place orders, and enjoy discounts, enhancing their dining experience directly through the website.",
      "imgs": [
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720192750/Portfolio/Screenshot_2024-07-05_at_8.47.53_PM_ffslxe.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720192749/Portfolio/Screenshot_2024-07-05_at_8.48.16_PM_kqhckw.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720192749/Portfolio/Screenshot_2024-07-05_at_8.48.29_PM_uh7vkp.png",
        "https://res.cloudinary.com/ddtzx1ohw/image/upload/v1720192750/Portfolio/Screenshot_2024-07-05_at_8.48.43_PM_otpc6t.png"
      ],
      "ghLink": "https://github.com/Pa1mekala37/Food-Munch",
      "demoLink": "https://hungryfoodmunch.ccbp.tech",
      "Technologies": [
        "HTML",
        "CSS",
        "Bootstrap",
        "Javascript"
      ]
    }
  ];

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 700,
    items: 1,
    autoplay: true,
    autoplayTimeout: 3000
  };

  @ViewChild('imgContainer') imgContainer: ElementRef;

  constructor() { }

  ngOnInit(): void { }

  debug() {
    this.imgContainer.nativeElement.scroll({
      top: this.imgContainer.nativeElement.scrollHeight,
      left: 0,
      behavior: 'smooth',
    });
  }
}
